<template>
    <router-view />
</template>

<script>
import { onBeforeMount } from "@vue/runtime-core";
import { useRouter } from "vue-router";
import PortalUserModel from "@/common/models/PortalUserModel";
import Utilities from "@/common/utilities";
import apiToken from "@/api/apiToken";
import { getCurrentInstance } from "@vue/runtime-core";

export default {
    setup() {
        const router = useRouter();

        // have to call it this way or else it didn't work when I called it after the login. 
        // Like it doesn't have access to getCurrentInstance() from with-in the login function
        const startListeners = getCurrentInstance().appContext.app.config.globalProperties.startListeners;
        
        onBeforeMount(async () => {
            
            const urlParams = new URLSearchParams(window.location.search);
            var key = urlParams.get("key");
            
            if (key !== null && key.length > 0) {
                var tokenAuto = await apiToken.autologin(key);
                if (tokenAuto !== null) {
                    localStorage.setItem("token", tokenAuto.token);
                }
            }

            var token = localStorage.getItem("token");
            if (token !== null) {
                var portalUser = PortalUserModel.fromToken();
                if (!portalUser.IsValid()) {
                    localStorage.clear();
                    router.replace("/Login");
                }         
                Utilities.startKeepAlive();                
                startListeners(portalUser.inactiveTimeout)
                router.replace("/Home");
            } else router.replace("/Login");
        });
    }
};
</script>

<style>
:root {
    
    /* OLD */
    /* --con-main-theme-color: #38b449; 
    --con-main-theme-card-header-color: black;
    --con-main-theme-card-header-color-2: #599F00;
    --con-main-theme-report-title: white; 
    --main-background: white;
    --menu-bar-background: rgb(77, 77, 77);
    --menu-bar-color: #38DC49;
    --anchor-color: #002EFB;
    --anchor-color-dark: #78CBCB;
    --con-main-search-color: white;
    --con-main-report-bar-background: grey;
    --con-main-report-bar-color: white;
    --input-radius: 0px;
    --con-main-status-container-background:#DADADA;
    --con-main-pos-status-container-background: white;
    --con-main-menu-bar-border: 2px black solid; 
    --con-main-login-image: url("/images/backgrounds/login3.jpg"); 
    --con-member-message-color: white; */
   
   
   
   

    /* NEW */
    --con-main-theme-color: #3c7458;
    --con-main-theme-card-header-color: white;
    --con-main-theme-card-header-color-2: #a8bbaa;
    --con-main-theme-report-title: black;
    --main-background: #f7f4f0;
    --menu-bar-background: #e4e7e1;
    --menu-bar-color: black;    
    --anchor-color: green;
    --anchor-color-dark: darkgreen;    
    --con-main-search-color: black;
    --con-main-report-bar-background: #f7f4f0;
    --con-main-report-bar-color: black;
    --input-radius: 4px;
    --con-main-status-container-background:#eee9e2;
    --con-main-pos-status-container-background: #eee9e2;
    --con-main-menu-bar-border: 0px black solid;        
    --con-main-login-image: url("./assets/login9.jpg");
    --con-member-message-color: black;
    /*--anchor-color: #0083ff;
    --anchor-color-dark: #0083ff;*/



    --main-color: black;
    --card-header-color: var(--con-main-theme-card-header-color);
    --card-header-background: var(--con-main-theme-color);

    --card-body-color: black;
    --card-body-background: white;
    --card-body-border: var(--con-main-theme-color);

    --delete-color: #fd3039;
    --delete-background: #ffcdd1;

    --delete-color-2: black;
    --delete-background-2: #FF9E80;

    --cancel-color: black;
    --cancel-background: #ececec;
    
    /* --------- */
    --action-color: black;
    --action-background: #EDF1F7;    

    --drop-area-background: #bbbbbb;

    --dragable-area-background: #0a4fb9;
    --dragable-area-color: white;

    --button-background: white;
    /* --button-color: #262626; */
    --button-color: #0a4fb9;

    --component-button-color: black;

    --admin-button-background: #0083ff;
    --admin-button-color: #FFFFFE;

    --collapsible-bar-background: #fafafa;
    --collapsible-bar-color: black;

    --collapsible-bar-background-hover: #fafafa;
    --collapsible-bar-color-hover: black;

    --input-background: white;
    --input-color: black;
    --input-background-disabled: grey;
    --input-color-disabled: black;
    --input-background-readonly: #f1f1f1;

    --input-border-color: var(--con-main-theme-color);
    --layout-edit: #503BC8;

    /* --anchor-color: #38b449; */
    --menuGroup-background: #2196e2;

    /* --button-radius: 1px 10px; */
    /* --button-border-radius: 10px 30px; */
    --button-radius: 5px;
    --button-border-radius: 15px;

    --body-font-family: "Roboto", sans-serif;

    --job-runner-color: #FFC107;
    --subscription-color: #523C73;
    --pincode-color: #8B6A4E;
    /* --job-runner-color: #FFEB3B; */    
}
body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* font-family: "Arial", "Times New Roman", Times, serif;   */
    /* font-family: "Nunito", "Arial", "Times New Roman", Times, serif; */
    font-family: var(--body-font-family);
    /* font-family: 'Open Sans', sans-serif;     */
    margin: 0px;
    /* min-width: 800px; */
    /* min-height: 600px; */
    background: var(--main-background);
    color: var(--main-color);
}

.template-base {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.template-base-not-100 {
    display: flex;
    flex-direction: column;
}

.select-button-container {
    display: flex;
    align-content: flex-start;
    background-color: var(--main-background);
    flex-direction: row;
    flex-wrap: wrap;
    /* overflow-y: scroll; */
}

.div-header {
    height: 5%;
}

.div-body {
    height: 95%;
}

.select-container {
    background-color: var(--main-background);
    align-content: flex-start;
}

.select-container-columns {
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
}
.select-container-rows {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    margin: auto;
}

.button-bar {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 30px;
    width: 100%;
}

button {
    border: 0px;
    background: var(--button-background);
    box-shadow: none;
    color: var(--button-color);
    cursor: pointer;
    width: 75px;
    padding: 10px;
}

/* button:focus {
    outline: 5;
    border: 1px solid black;
} */

datalist {
    display: none;
}

.backdrop {
    top: 0;
    left: 0;
    position: fixed;
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    z-index: 99;
}

.modal {
    width: 70%;
    height: 50%;
    margin: 100px auto;
    background: white;
    /* border-radius: 10px; */
}

.card-header {
    background-color: var(--card-header-background);
    color: var(--card-header-color);
    padding-top: 10px;
    height: 30px;
    width: 100%;
    border-bottom: 1px solid var(--card-body-border);
    text-align: center;
    font-size: 18px;
    border-radius: var(--button-border-radius) var(--button-border-radius) 0 0;
}

.card-body {
    background-color: var(--card-body-background);
    color: var(--card-body-color);
    /* margin: 10px 20px; */
    margin: 10px 0px 20px 40px;
    border: 1px solid var(--card-body-border);
    border-radius: var(--button-border-radius);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
}

/* Style the button that is used to open and close the collapsible content */
.collapsible {
    background-color: var(--collapsible-bar-background);
    color: var(--collapsible-bar-color);
    cursor: pointer;
    padding: 10px;
    width: 100%;
    border: none;
    text-align: left;
    outline: none;
    font-size: 15px;
    margin: auto;
}

/* Add a background color to the button if it is clicked on (add the .active class with JS), and when you move the mouse over it (hover) */
.active,
.collapsible:hover {
    background-color: var(--collapsible-bar-background-hover);
    color: var(--collapsible-bar-color-hover);
}

input:focus {
  outline: none;
  /* box-shadow: 0 0 0 3px rgba(10, 79, 185, 0.25); */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
}


input[type="text"] {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background);
    color: var(--input-color);
    /* text-align: right; */
    padding: 5px;    
    border-radius: var(--input-radius);
}


input[type="email"] {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background);
    color: var(--input-color);
    /* text-align: right; */
    padding: 5px;
    border-radius: var(--input-radius);
}

input[type="address"] {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background);
    color: var(--input-color);
    /* text-align: right; */
    padding: 5px;
    border-radius: var(--input-radius);
}

input[type="tel"] {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background);
    color: var(--input-color);
    /* text-align: right; */
    padding: 5px;
    border-radius: var(--input-radius);
}

input[type="text"]:disabled {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background-readonly);
    color: var(--input-color-disabled);
    /* text-align: right; */
    padding: 5px; 
}

input[type="password"] {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background);
    color: var(--input-color);
    /* text-align: right; */
    padding: 5px;
    border-radius: var(--input-radius);
}

input[type="password"]:disabled {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background-readonly);
    color: var(--input-color-disabled);
    /* text-align: right; */
    padding: 5px;
}


input[type="email"]:disabled {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background-readonly);
    color: var(--input-color-disabled);
    /* text-align: right; */
    padding: 5px;
}

input[type="text"]:read-only {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background-readonly);
    color: var(--input-color-disabled);
    /* text-align: right; */
    padding: 5px;
}

input[type="email"]:read-only {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background-readonly);
    color: var(--input-color-disabled);
    /* text-align: right; */
    padding: 5px;
}

input[type="tel"]:read-only {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background-readonly);
    color: var(--input-color-disabled);
    /* text-align: right; */
    padding: 5px;
}

input[type="address"]:read-only {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background-readonly);
    color: var(--input-color-disabled);
    /* text-align: right; */
    padding: 5px;
}

input[type="number"] {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background);
    color: var(--input-color);
    padding: 5px;
    border-radius: var(--input-radius);
}

input[type="number"]:disabled {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background-disabled);
    color: var(--input-color-disabled);
    padding: 5px;
}

input[type="datetime-local"] {    
    border-radius: var(--input-radius);
}

input[type="number"]:read-only {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background-readonly);
    color: var(--input-color-disabled);
    padding: 5px;
}

select {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background);
    color: var(--input-color);
    padding: 5px;
    border-radius: var(--input-radius);
    /* for Chrome */
    /* -webkit-appearance: none; */
    /* for Firefox */
    /* -moz-appearance: none; */
}

select:disabled {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background-readonly);
    color: var(--input-color-disabled);
    padding: 5px;
    /* for Chrome */
    /* -webkit-appearance: none; */
    /* for Firefox */
    /* -moz-appearance: none; */
}

.smaller-button {
    max-width: 100px;
    max-height: 100px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
}

.x-smaller-button {
    max-width: 75px;
    max-height: 75px;
}

textarea {
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background);
    color: var(--input-color);
    border-radius: var(--input-radius);
}

textarea:focus,
input:focus,
select:focus,
button:focus {
    /* outline: none; */
    outline: 1px solid green;
}

textarea:focus-visible,
input:focus-visible,
select:focus-visible,
button:focus-visible {
    /* outline: none; */
    outline: 1px solid green;
}

.menu-bar {
    background: var(--menu-bar-background);
    color: var(--menu-bar-color);
    display: flex;
    padding: 5px 5px;
    border-bottom: var(--con-main-menu-bar-border);
    border-radius: var(--button-border-radius) var(--button-border-radius) 0 0;
}

.administrator-button {
    padding: 5px;
    margin-right: 10px;
    width: 80px;
    /* border: 1px solid black; */
    cursor: pointer;
    border-radius: var(--button-radius);
    background-color: var(--admin-button-background);
    color: var(--admin-button-color);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
}

.administrator-button-bar {
    display: flex;
    justify-content: flex-end;
    padding: 5px;
    margin: 0px;
    margin-bottom: 10px;
    height: 30px;
}

.administrator-input-item-numeric {
    text-align: right;
}

.button-delete {
    background-color: var(--delete-background);
    color: var(--delete-color);
}

.button-delete-2 {
    background-color: var(--delete-background-2);
    color: var(--delete-color-2);
}

.button-cancel {
    background-color: var(--cancel-background);
    color: var(--cancel-color);
}

.button-action {
    background-color: var(--action-background);
    color: var(--action-color);
}

a {
    text-decoration: none;
    color: var(--anchor-color);
}

.button-link {
    background: none !important;
    border: none;
    padding: 0 !important;
    /*optional*/
    font-family: arial, sans-serif;
    /*input has OS specific font-family*/
    color: var(--anchor-color);
    text-decoration: none;
    cursor: pointer;
    font-size: 13px;
}

.button-link:disabled {
    background: none !important;
    border: none;
    padding: 0 !important;
    /*optional*/
    font-family: arial, sans-serif;
    /*input has OS specific font-family*/
    color: gray;
    text-decoration: none;
    cursor: default;
    font-size: 13px;
}

.button-link-dark {
    background: none !important;
    border: none;
    padding: 0 !important;
    /*optional*/
    font-family: arial, sans-serif;
    /*input has OS specific font-family*/
    color: var(--anchor-color-dark);
    text-decoration: none;
    cursor: pointer;
    font-size: 13px;
}

.button-link-dark:disabled {
    background: none !important;
    border: none;
    padding: 0 !important;
    /*optional*/
    font-family: arial, sans-serif;
    /*input has OS specific font-family*/
    color: gray;
    text-decoration: none;
    cursor: default;
    font-size: 13px;
}

@font-face {
    font-family: "password";
    font-style: normal;
    font-weight: 400;
    src: url(https://jsbin-user-assets.s3.amazonaws.com/rafaelcastrocouto/password.ttf);
}

/* ---------------------------------------------------- */
/* For Reports */

.report-container {
    margin: 10px;
}

.report-title {
    background-color: var(--con-main-theme-card-header-color-2);
    color: var(--con-main-theme-report-title);
    font-size: 14pt;
    margin: 0px;
    padding: 4px 10px;
}

.report-export {
    color: black;
    padding: 2px 8px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 10pt;
    cursor: pointer;
}

.report-container {
    display: flex;
    flex-direction: column;
}

.report-card {
    background: white;
    /* border-radius: 6px; */
    width: 99%;
    /* margin-bottom: 10px; */
    border-bottom: 1px solid black;
    padding: 6px;
    font-size: 11pt;
}

.report-div-table {
    width: 100%;
    /* padding: auto; */
}

tr.report-div-table-row-totals td {
    border-bottom: 1px solid black;
    background: #b8c8e0;
    color:black;
}

tr.report-div-table-row td {
    border-bottom: 1px solid black;
}

tr.report-div-table-row:hover td {
    background: #ddf0f8;
}

tr:nth-child(even) {
    background-color: rgb(221, 220, 220);
}

tr:nth-child(odd) {
    background-color: white;
}

.report-div-table-col {
    font-size: 10pt;
    text-align: left;
    padding-left: 10px;
    padding-right: 10px;
    color: black;
}

.report-div-table-col-small {
    font-size: 9pt;
    text-align: left;
    padding-left: 10px;
    padding-right: 10px;
    color: black;
}

.tooltip {
    position: relative;
    display: inline-block;
    /* border-bottom: 1px dotted black; */
}

.tooltip .tooltiptext {
    background-color: gray;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 5px;
    position: relative;
    font-size: 9pt;
    top: -20px;
    left: -100px;
}

.helptip {
    position: absolute;
    display: inline-block;
    cursor: pointer;
    /* border-bottom: 1px dotted black; */
}

.helptip .helptiptext {
    background-color: lightblue;
    color: black;
    text-align: left;
    border-radius: 6px;
    padding: 5px 5px;
    position: absolute;
    font-size: 9pt;
    top: 25px;
    left: -200px;
    width: 200px;
    cursor: pointer;
}

.div-table {
    width:100%;
    display:flex;
    flex-direction: column;
    overflow-y: auto;
}

.div-table-row {
    display: flex;
    flex-direction: row;
    padding: 0px;
    width:100%;
    margin-top: 10px ;
}

.div-table-cell {
    display: flex;
    flex-direction: column;
    margin-left: 20px ;    
}

.credit-value {
    /* color: rgb(40, 40, 40) */
    color: #006A4E
    
}

.job-runner-border {
    border: 3px solid var(--job-runner-color);
}

.header-divider {
    background-color: var(--card-body-border);
    height: 1px;
}

</style>
